export default {
  about_us: 'Tentang Kami',
  alphabet_az: 'Judul A-Z',
  alphabet_za: 'Judul Z-A',
  back: 'Kembali',
  compare: 'Bandingkan',
  compare_helper: 'Masukkan nama model atau bagiannya.',
  comparison: 'Pembanding',
  contact_us: 'Hubungi Kami',
  copyright: '&copy; {year} {sitename}. Seluruh hak cipta dilindungi.',
  dashboard: 'Dasbor',
  find_laptop: 'Cari laptop',
  finder: 'Cari',
  finder_result: 'Hasil Pencarian',
  highest_price: 'Harga Tertinggi',
  home: 'Beranda',
  laptop_finder: 'Cari Laptop',
  laptops_type: 'Laptop {title}',
  last_modified: 'Pembaruan Terakhir',
  latest: 'Terbaru',
  latest_comparison: 'Perbandingan Terbaru',
  login: 'Masuk',
  login_signup: 'Masuk/Daftar',
  logout: 'Keluar',
  lowest_price: 'Harga Terendah',
  news: 'Berita',
  oldest: 'Terlama',
  popular_comparison: 'Perbandingan Terpopuler',
  price: 'Harga',
  privacy_policies: 'Kebijakan Privasi',
  product_title: 'Spesifikasi lengkap {name}',
  products: 'Produk',
  see_all: 'Lihat semua',
  show_all: 'Tampilkan semua',
  submit: 'Kirim',
  sort: 'Urutkan',
  sort_by: 'Urutkan',
  terms_conditions: 'Syarat & Ketentuan',
  types: 'Tipe',
  wishlist: 'Wishlist',
};
